/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vast_Vivid_Hawk_SlipInputs */

const en_vast_vivid_hawk_slip = /** @type {(inputs: Vast_Vivid_Hawk_SlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import in progress`)
};

const de_vast_vivid_hawk_slip = /** @type {(inputs: Vast_Vivid_Hawk_SlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import wird erstellt`)
};

/**
* | output |
* | --- |
* | "Import in progress" |
*
* @param {Vast_Vivid_Hawk_SlipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vast_vivid_hawk_slip = /** @type {((inputs?: Vast_Vivid_Hawk_SlipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vast_Vivid_Hawk_SlipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vast_vivid_hawk_slip(inputs)
	return de_vast_vivid_hawk_slip(inputs)
});